import { useAtomValue } from 'jotai'
import { RequestCourseForm } from '@/components/RequestCourse/RequestCourseForm'
import RequestHistoryTable from '@/components/RequestCourse/RequestHistoryTable'
import { userAtom } from '@/store/store'

const RequestCourse = () => {
    const user = useAtomValue(userAtom)
    return (
        <div className="flex flex-col h-full w-full items-center px-4 py-6">
            {user.userExists === false && (
                <div className="mb-4 w-full max-w-2xl rounded-lg border border-blue-200 bg-blue-50 p-4 dark:border-blue-900 dark:bg-blue-950">
                    <h3 className="text-sm font-semibold text-blue-800 dark:text-blue-200">Limited Access</h3>
                    <p className="mt-1 text-sm text-blue-700 dark:text-blue-300">
                        Your account is not yet registered in the system. You can submit a course request below.
                        Once approved, you will be granted full access.
                    </p>
                </div>
            )}
            <section className="w-full pt-4">
                <RequestCourseForm />
            </section>
            <RequestHistoryTable />
        </div>
    )
}

export default RequestCourse
